

<ng-container *ngIf="!eventService.loadEventTournaments; else loading">

<ng-container *ngIf="(eventService.eventTournaments|async)?.data != 0; else nodata">

<div class="tournamentsCon" >

  <a class="tournamentCard" *ngFor="let tournament of (eventService.eventTournaments|async)?.data"
     href="https://www.gbarena.com/tournaments/{{ tournament.code }}"
  >

    <div class="topBanner">
      <img src="{{tournament.cover_picture}}" class="img-responsive" >
      <a class="new_button" href="https://www.gbarena.com/tournaments/{{tournament.code}}">
        Join Now
      </a>
    </div>
    <div class="body">
      <h1>{{ tournament.name }}</h1>
      <div class="midCon">
        <div class="date">
          <div class="item">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14.55 16.628">
              <path
                d="M0,15.069a1.559,1.559,0,0,0,1.559,1.559H12.991a1.559,1.559,0,0,0,1.559-1.559V6.236H0ZM10.393,8.7a.391.391,0,0,1,.39-.39h1.3a.391.391,0,0,1,.39.39V10a.391.391,0,0,1-.39.39h-1.3a.391.391,0,0,1-.39-.39Zm0,4.157a.391.391,0,0,1,.39-.39h1.3a.391.391,0,0,1,.39.39v1.3a.391.391,0,0,1-.39.39h-1.3a.391.391,0,0,1-.39-.39ZM6.236,8.7a.391.391,0,0,1,.39-.39h1.3a.391.391,0,0,1,.39.39V10a.391.391,0,0,1-.39.39h-1.3a.391.391,0,0,1-.39-.39Zm0,4.157a.391.391,0,0,1,.39-.39h1.3a.391.391,0,0,1,.39.39v1.3a.391.391,0,0,1-.39.39h-1.3a.391.391,0,0,1-.39-.39ZM2.079,8.7a.391.391,0,0,1,.39-.39h1.3a.391.391,0,0,1,.39.39V10a.391.391,0,0,1-.39.39h-1.3a.391.391,0,0,1-.39-.39Zm0,4.157a.391.391,0,0,1,.39-.39h1.3a.391.391,0,0,1,.39.39v1.3a.391.391,0,0,1-.39.39h-1.3a.391.391,0,0,1-.39-.39ZM12.991,2.079H11.432V.52a.521.521,0,0,0-.52-.52H9.873a.521.521,0,0,0-.52.52V2.079H5.2V.52A.521.521,0,0,0,4.677,0H3.637a.521.521,0,0,0-.52.52V2.079H1.559A1.559,1.559,0,0,0,0,3.637V5.2H14.55V3.637A1.559,1.559,0,0,0,12.991,2.079Z"
                fill="#0c074a"/>
            </svg>
            {{tournament.start_at | date:'shortDate'}}</div>
          <div class="item">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.574 16.574">
              <path
                d="M8.85.563A8.287,8.287,0,1,0,17.137,8.85,8.286,8.286,0,0,0,8.85.563Zm1.908,11.7L7.81,10.119A.4.4,0,0,1,7.647,9.8V4.171a.4.4,0,0,1,.4-.4h1.6a.4.4,0,0,1,.4.4v4.6l2.122,1.544a.4.4,0,0,1,.087.561l-.942,1.3A.4.4,0,0,1,10.758,12.261Z"
                transform="translate(-0.563 -0.563)" fill="#0c074a"/>
            </svg>
            {{tournament.start_at | date:'shortTime'}}</div>
        </div>
        <div class="status" style="display: flex; justify-content: flex-start; align-items: center;">

          <div class="icon"
               [ngClass]="{'active':tournament.status=='Waiting Players to Join',
                                  'finished':tournament.status=='Finished', 'inprogress':tournament.status=='In Progress',
                                  'closed':tournament.status=='Registration Closed'}"></div>

          <p *ngIf="tournament.status=='Waiting Players to Join'">Open</p>
          <p *ngIf="tournament.status=='inprogress'">In Progress</p>
          <p *ngIf="tournament.status=='Finished'">Finished</p>
          <p *ngIf="tournament.status=='Registration Closed'">Closed</p>

        </div>
      </div>


    </div>
  </a>


</div>
</ng-container>
</ng-container>


<ng-template #nodata>
  <div class="container">
  <div class=" no-data">
    <h2>{{globalService.customLang.no_tournaments_yet}}</h2>
  </div>
  </div>
</ng-template>


<ng-template #loading>
  <app-loading-indicator></app-loading-indicator>
</ng-template>
